/* Extracted from snippets/product-gravurarten.liquid */
(function (window, document) {
  var GravurDeferred = {
    loaded: false,
    promise: null,
    ensure: function () {
      if (this.loaded) return Promise.resolve();
      if (this.promise) return this.promise;
      this.promise = loadGravurPanels().then(function () {
        GravurDeferred.loaded = true;
        document.dispatchEvent(new CustomEvent('gravur:panels-ready'));
      }).catch(function (err) {
        console.error('Gravur panels failed to load', err);
        GravurDeferred.promise = null;
      });
      return this.promise;
    }
  };
  window.GravurDeferred = GravurDeferred;

  function loadGravurPanels() {
    var root = document.querySelector('.gravuroptions[data-gravur-panels-url]');
    if (!root) {
      GravurDeferred.loaded = true;
      return Promise.resolve();
    }
    if (!root.querySelector('[data-gravur-deferred="true"]')) {
      GravurDeferred.loaded = true;
      return Promise.resolve();
    }
    var url = root.getAttribute('data-gravur-panels-url');
    return fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.text();
    }).then(function (html) {
      if (html.indexOf('data-gravur-deferred-side') === -1) {
        throw new Error('Deferred panels missing from response');
      }
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var sides = doc.querySelectorAll('[data-gravur-deferred-side]');
      sides.forEach(function (node) {
        var side = node.getAttribute('data-gravur-deferred-side');
        var target = document.getElementById('tab-content-motiv-' + side);
        if (!target) return;
        while (node.firstChild) target.appendChild(node.firstChild);
        target.removeAttribute('data-gravur-deferred');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { GravurDeferred.ensure(); });
  } else {
    GravurDeferred.ensure();
  }
})(window, document);


document.addEventListener('DOMContentLoaded', function () {
    const videoPopup = document.querySelector('.video_popup');
    const modal = document.getElementById('videoModal');
    const closeBtn = document.querySelector('.video-modal-close');
    const video = document.getElementById('popupVideo');
    const header = document.getElementById('shopify-section-header');

    if (videoPopup && modal && closeBtn && video) {
      videoPopup.addEventListener('click', function (e) {
        e.preventDefault();
        modal.style.display = 'flex';
        document.body.classList.add('modal-open');

        if (header) {
          header.style.zIndex = '0';
        }

        video.play();
      });

      closeBtn.addEventListener('click', function () {
        modal.style.display = 'none';
        document.body.classList.remove('modal-open');

        if (header) {
          header.style.zIndex = '';
        }

        video.pause();
        video.currentTime = 0;
      });

      window.addEventListener('click', function (e) {
        if (e.target == modal) {
          modal.style.display = 'none';
          document.body.classList.remove('modal-open');

          if (header) {
            header.style.zIndex = '';
          }

          video.pause();
          video.currentTime = 0;
        }
      });

      window.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.style.display === 'block') {
          modal.style.display = 'none';
          document.body.classList.remove('modal-open');

          if (header) {
            header.style.zIndex = '';
          }

          video.pause();
          video.currentTime = 0;
        }
      });
    }
  });

  /* Cart submit is handled by assets/custom.js CustomAddToCart.
     Do not declare CustomAddToCart here — it would overwrite that handler. */
  $(document).ready(function () {
    $('#AddToCartCustomss').on('click', function (event) {
      alert('custom add to cart');
      event.preventDefault(); // Prevent default form submission behavior
      var total_properties_needed = 0;
      var total_addon_price = 0;
      $('.all_total_values_count').each(function () {
        console.log($(this).val());
        if ($(this).val() > 0) {
          total_properties_needed = parseInt(total_properties_needed) + parseInt($(this).val());
          total_addon_price = parseInt(total_addon_price) + parseInt(10);
        }
      });
      //alert(total_properties_needed+'needed properties');

      $('.custom_properties').html('');
      var total_values_added = 0;
      $('.items').each(function () {
        if ($(this).hasClass('No-engraving') == false) {
          if ($(this).hasClass('active')) {
            var propertyname = $(this).attr('data-property-name');
            var propertyvalue = $(this).attr('data-property-value');
            const inputElement = $('<input>', {
              type: 'hidden',
              name: `properties[${propertyname}]`,
              value: propertyvalue,
            });
            total_values_added = parseInt(total_values_added) + parseInt(1);
            // Append the input element to the specified class
            $(`.custom_properties`).append(inputElement);
            console.log('This .items element has the active class:', this);
          }
        }
      });
      $('.motive_text').each(function () {
        if ($(this).val() != '') {
          var propertyname = $(this).attr('data-attr-name');
          var propertyvalue = $(this).val();
          const inputElement = $('<input>', {
            type: 'hidden',
            name: `properties[${propertyname}]`,
            value: propertyvalue,
          });
          total_values_added = parseInt(total_values_added) + parseInt(1);
          $(`.custom_properties`).append(inputElement);
        }
      });

      $('.file_upload').each(function (index, element) {
        if ($(element).attr('type') === 'file') {
          // Check if the element is of type 'file'
          const fileInput = $(element)[0]; // Get the DOM element
          const files = fileInput.files; // Get the FileList object

          if (files.length > 0) {
            total_values_added = parseInt(total_values_added) + parseInt(1);
            /*const file = files[0]; // Get the first file
            console.log(`File ${index + 1}:`);
            console.log('Name:', file.name);
            console.log('Size:', file.size);
            console.log('Type:', file.type);*/
          }
        }
      });

      // Send Addon Price
      if ($('.selected_customisable_product').length > 0) {
        if ($('.selected_customisable_product').attr('data-product-price') > 0) {
          const inputElement = $('<input>', {
            type: 'hidden',
            name: `properties[Related Product]`,
            value: $('.selected_customisable_product').attr('data-product-name'),
          });
          $(`.custom_properties`).append(inputElement);
          var related_product_price = parseInt($('.selected_customisable_product').attr('data-product-price')) / 100;
          total_addon_price = parseFloat(total_addon_price) + parseFloat(related_product_price);
        }
      }
      if (total_addon_price > 0) {
        const inputElement = $('<input>', {
          type: 'hidden',
          name: `properties[_Total Addon Price]`,
          value: total_addon_price,
        });
        $(`.custom_properties`).append(inputElement);
      }

      alert(total_values_added);
      return false;
      if (parseInt(total_properties_needed) == parseInt(total_values_added)) {
        //$('form.shopify-product-form').submit();
        $('#AddToCart').trigger('click');
      } else {
        alert('Please add all the selected fields');
      }

      /*const tabContents = document.querySelectorAll('.gravuroptions .tab-contents .tab-content');

      tabContents.forEach(function (tabContent) {
        const gravurartItems = tabContent.querySelectorAll('.gravurart-items');

        gravurartItems.forEach(function (item) {
          if (item.classList.contains('active')) {
            const propertyName = item.getAttribute('data-property-name');
            const dataType = item.getAttribute('data-type');

            console.log('Property Name:', propertyName);
            console.log('Data Type:', dataType);
          }
        });
      // Trigger the form submission
      //$('form.shopify-product-form').submit();
    });*/
    });
  });
  function fontclick(fontfamily, element) {
    const $element = $(element);

    // Traverse to the nearest `.font_lists` parent and remove 'active' class from its children
    $element.closest('.font_lists').find('li').removeClass('active');

    // Add 'active' class to the clicked element
    $element.addClass('active');

    // Apply the font family (if needed, optional)
    $element.css('font-family', fontfamily);

    if (fontfamily) {
      let motivelist = element.closest('.motivelist'); // Adjust selector as needed
      let inputElement = motivelist.querySelector('.engraving-text > textarea');

      if (inputElement) {
        inputElement.style.fontFamily = fontfamily;
        inputElement.disabled = false;
      }
    }

    let parenttab = element.closest('.parent-tab-content');
    const tabindex = parenttab.getAttribute('data-tab-index');
    let parenttabs = element.closest('.parents-tab-contents');
    let fontselection = element.closest('.font-selection');
    const inputtext = fontselection.querySelector('.engraving-text .motive_text');
    let height = inputtext.offsetHeight + 10;
    if (inputtext && inputtext.value.trim() !== '') {
      let summaryContainerText = parenttabs.querySelector(`.option-summary #motiv_summary_${tabindex} .inputbox_html`);
      if (summaryContainerText) {
        // Clear the existing content
        summaryContainerText.innerHTML = '';
        let cleanedText = inputtext.value
          .split('\n')
          .map((line) => line.trimStart()) // remove leading spaces/tabs
          .join('\n');
        // Insert the new content with the input value and font-family style if it's not empty
        summaryContainerText.innerHTML = `
          <div class="_text">
            <textarea data-attr-name="" cols="95" rows="3" name="selectedtext" readonly${
              fontfamily ? ` style="resize: none; font-family: ${fontfamily};" height:${height}px !important;` : ''
            }>${inputtext.value}
            </textarea>
          </div>
           
        `;

        // Insert the new content with the input value and font-family style if it's not empty
        /*summaryContainerText.innerHTML = `
          <div class="_text">
            <input type="text" data-attr-name="" name="selectedtext" value="${inputtext.value}" readonly${fontfamily ? ` style="font-family: ${fontfamily};"` : ''}>
          </div>
        `;*/
      }
    }
    let summaryContainer = parenttabs.querySelector(
      `.option-summary #motiv_summary_${tabindex} .selected_summary .fonts_html`
    );
    if (summaryContainer) {
      summaryContainer.innerHTML = '';
      summaryContainer.innerHTML += `<p class="font-heading">Schriftart & Gravurtext</p>
<svg width="17" height="11" viewBox="0 0 17 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.0376 0.810059L9.4541 10.5H8.11377L7.02246 8.1123H3.06006L1.99805 10.5H0.672363L5.0376 0.810059ZM3.54346 7.05029H6.53906L5.0376 3.73242L3.54346 7.05029ZM10.0913 7.49707C10.0913 7.05273 10.1646 6.63525 10.311 6.24463C10.4575 5.854 10.6626 5.51465 10.9263 5.22656C11.1948 4.93848 11.5146 4.71143 11.8857 4.54541C12.2568 4.37451 12.667 4.28906 13.1162 4.28906C13.3164 4.28906 13.519 4.30615 13.7241 4.34033C13.9292 4.37451 14.1245 4.43066 14.3101 4.50879C14.5005 4.58691 14.6763 4.68701 14.8374 4.80908C15.0034 4.92627 15.145 5.07275 15.2622 5.24854V4.45752H16.5366V10.5H15.2769V9.61377C15.2231 9.72119 15.145 9.82129 15.0425 9.91406C14.9448 10.0068 14.835 10.0923 14.7129 10.1704C14.5957 10.2437 14.4712 10.3096 14.3394 10.3682C14.2124 10.4268 14.0952 10.4756 13.9878 10.5146C13.7046 10.6172 13.3604 10.6685 12.9551 10.6685C12.5205 10.6685 12.125 10.5806 11.7686 10.4048C11.417 10.2241 11.1167 9.9873 10.8677 9.69434C10.6187 9.39648 10.4258 9.05713 10.2891 8.67627C10.1572 8.29541 10.0913 7.90234 10.0913 7.49707ZM13.27 9.52588C13.563 9.52588 13.8315 9.47461 14.0757 9.37207C14.3198 9.26465 14.5298 9.12061 14.7056 8.93994C14.8813 8.75439 15.0181 8.53955 15.1157 8.29541C15.2134 8.04639 15.2622 7.78027 15.2622 7.49707C15.2622 7.20898 15.2109 6.94043 15.1084 6.69141C15.0107 6.44238 14.8716 6.2251 14.6909 6.03955C14.5151 5.84912 14.3052 5.7002 14.061 5.59277C13.8218 5.48535 13.5581 5.43164 13.27 5.43164C12.9868 5.43164 12.7256 5.49023 12.4863 5.60742C12.252 5.71973 12.0493 5.87354 11.8784 6.06885C11.7124 6.25928 11.583 6.48145 11.4902 6.73535C11.3975 6.98438 11.3511 7.24316 11.3511 7.51172C11.3511 7.80957 11.395 8.08301 11.4829 8.33203C11.5708 8.58105 11.6978 8.79346 11.8638 8.96924C12.0298 9.14502 12.23 9.28174 12.4644 9.37939C12.7036 9.47705 12.9722 9.52588 13.27 9.52588Z" fill="black"/>
</svg>
`;
    }

    var pid = $(element).attr('data-product-id');
    showSummaryButton(pid);
  }
  function sternzeichen_click(value, fcount, pid, element) {
    if ($(element).hasClass('active') == false) {
      removeAllValues(pid);
      let initialenItems = element.closest('.list').querySelectorAll('li');
      initialenItems.forEach(function (li) {
        // Check if the 'li' has the 'active' class
        if (li.classList.contains('active')) {
          // Remove the 'active' class
          li.classList.remove('active');
        }
      });
      element.classList.add('active');

      let parenttab = element.closest('.parent-tab-content');
      const tabindex = parenttab.getAttribute('data-tab-index');
      let parenttabs = element.closest('.parents-tab-contents');

      let select_Geburtsblume_box = parenttabs.querySelector(
        `.option-summary #motiv_summary_${tabindex} .selected_summary .select_Geburtsblume_box`
      );
      if (select_Geburtsblume_box) {
        // Clear previous content (optional, if you want to replace)
        select_Geburtsblume_box.innerHTML = '';
      }
      let select_file_box = parenttabs.querySelector(
        `.option-summary #motiv_summary_${tabindex} .selected_summary .select_file_box`
      );
      if (select_file_box) {
        select_file_box.innerHTML = '';
        select_file_box.innerHTML += element.innerHTML;
      }
      showSummaryButton(pid);
    }
  }

  function geburtsblumen_options_click(value, limit, pid, element) {
    if (!element.classList.contains('active')) {
      console.log(element.innerHTML); // Correct way to get inner HTML in vanilla JS

      // Remove 'active' from all sibling items
      element
        .closest('.geburtsblumen_info')
        .querySelectorAll('li.items')
        .forEach(function (li) {
          li.classList.remove('active');
        });

      // Add 'active' to the clicked element
      element.classList.add('active');

      // Find the closest h3 within .motivelist and get its text content
      if (limit) {
        var parent_counter = $('.product_' + pid).attr('data-stepone-count');
        var new_counter = parseInt(parent_counter) + parseInt(limit);
        $('.product_' + pid).val(new_counter);
      }
      let parenttab = element.closest('.parent-tab-content');
      const tabindex = parenttab.getAttribute('data-tab-index');
      let parenttabs = element.closest('.parents-tab-contents');

      // Hide all .geburtsblumen inside this motiv_summary
      const hideAll = parenttabs.querySelectorAll(`.motivelist .geburtsblumen`);
      hideAll.forEach((el) => {
        el.style.display = 'none';
        // Also remove 'active' class from all <li> inside each .geburtsblumen
        el.querySelectorAll('li').forEach((li) => {
          li.classList.remove('active');
        });
      });

      let select_file_box = parenttabs.querySelector(
        `.option-summary #motiv_summary_${tabindex} .selected_summary .select_file_box`
      );
      if (select_file_box) {
        select_file_box.innerHTML = '';
        select_file_box.innerHTML += element.innerHTML;
      }
      // Show only the one with the matching count
      const geburtsblumen_show = parenttabs.querySelector(`.motivelist .geburtsblumen.count_${limit}`);

      if (geburtsblumen_show) {
        geburtsblumen_show.style.display = 'block';
        // Loop through each <ul> inside the shown .geburtsblumen
        const allUls = geburtsblumen_show.querySelectorAll('ul.list');
        allUls.forEach((ul) => {
          const firstLi = ul.querySelector('li');
          if (firstLi) {
            firstLi.click();
          }
        });
      }

      // Find the closest h3 within .motivelist and get its text content
      const heading = element.closest('.motivelist').querySelector('.motivelist-title')?.textContent;
      if (heading != null) {
        // Update the innerHTML of the h3 inside .selected_summary with the heading text
        const selectedSummaryHeading = parenttabs.querySelector(
          `.option-summary .selected_motiv_option#motiv_summary_${tabindex} .selected_summary > .heading`
        );
        // if (selectedSummaryHeading) {
        //  selectedSummaryHeading.innerHTML = heading;
        // }
      }
      //showSummaryButton(pid);
    }
  }

  function geburtsblumen_click(value, fcount, pid, element) {
    if ($(element).hasClass('active') == false) {
      //0removeAllValues(pid);
      //let initialenItems = element.closest('.list').querySelectorAll('li');
      let initialenItems = element.closest('ul.list').querySelectorAll('li');
      initialenItems.forEach(function (li) {
        // Check if the 'li' has the 'active' class
        if (li.classList.contains('active')) {
          // Remove the 'active' class
          li.classList.remove('active');
        }
      });
      element.classList.add('active');
      // Find the closest h3 within .motivelist and get its text content

      let parenttab = element.closest('.parent-tab-content');
      const tabindex = parenttab.getAttribute('data-tab-index');
      let parenttabs = element.closest('.parents-tab-contents');

      //let gbt_limit = element.closest('.geburtsblumen').getAttribute('data-count');

      let geburtsblumenBox = element.closest('.geburtsblumen');
      let gbt_limit = parseInt(geburtsblumenBox.getAttribute('data-count'), 10);

      // Find the target container to append into
      let select_Geburtsblume_box = parenttabs.querySelector(
        `.option-summary #motiv_summary_${tabindex} .selected_summary .select_Geburtsblume_box`
      );

      // Clear previous content (optional, if you want to replace)
      select_Geburtsblume_box.innerHTML = '';

      // Loop through each <ul class="list"> inside .geburtsblumen
      let lists = geburtsblumenBox.querySelectorAll('ul.list');
      lists.forEach((ul, index) => {
        let activeLi = ul.querySelector('li.active');
        if (activeLi) {
          // Create the wrapper divs
          let wrapper = document.createElement('div');
          wrapper.className = 'gbb_count';

          let rowDiv = document.createElement('div');
          rowDiv.setAttribute('row', index + 1); // row="1", "2", etc.
          rowDiv.innerHTML = activeLi.innerHTML;

          wrapper.appendChild(rowDiv);
          select_Geburtsblume_box.appendChild(wrapper);
        }
      });

      // let geburt_option = parenttabs.querySelector(`.motivelist .geburtsblumen.count_${limit}`);

      // let select_file_box = parenttabs.querySelector(`.option-summary #motiv_summary_${tabindex} .selected_summary .select_file_box`);
      // if(select_file_box) {
      //   select_file_box.innerHTML = '';
      //   select_file_box.innerHTML += element.innerHTML;
      // }
      // Find the closest h3 within .motivelist and get its text content
      const heading = element.closest('.motivelist').querySelector('.motivelist-title')?.textContent;
      if (heading != null) {
        // Update the innerHTML of the h3 inside .selected_summary with the heading text
        const selectedSummaryHeading = parenttabs.querySelector(
          `.option-summary .selected_motiv_option#motiv_summary_${tabindex} .selected_summary > .heading`
        );
        if (selectedSummaryHeading) {
          //selectedSummaryHeading.innerHTML = heading;
        }
      }
      showSummaryButton(pid);
    }
  }
  /*function geburtsblumen_click(value, fcount, pid, element) { 
  if ($(element).hasClass('active') == false) {
    removeAllValues(pid);
    let initialenItems = element.closest('.list').querySelectorAll('li');
    initialenItems.forEach(function(li) {
        // Check if the 'li' has the 'active' class
        if (li.classList.contains('active')) {
            // Remove the 'active' class
            li.classList.remove('active');
        }
    });
    element.classList.add('active');
    // Find the closest h3 within .motivelist and get its text content
      
    let parenttab = element.closest('.parent-tab-content');
    const tabindex = parenttab.getAttribute('data-tab-index');
    let parenttabs = element.closest('.parents-tab-contents');
    let select_file_box = parenttabs.querySelector(`.option-summary #motiv_summary_${tabindex} .selected_summary .select_file_box`);
    if(select_file_box) {
      select_file_box.innerHTML = '';
      select_file_box.innerHTML += element.innerHTML;
    }
    // Find the closest h3 within .motivelist and get its text content
    const heading = element.closest('.motivelist').querySelector('.motivelist-title')?.textContent;
    if (heading != null) {
    // Update the innerHTML of the h3 inside .selected_summary with the heading text
    const selectedSummaryHeading = parenttabs.querySelector(`.option-summary .selected_motiv_option#motiv_summary_${tabindex} .selected_summary > .heading`);
     // if (selectedSummaryHeading) {
     //  selectedSummaryHeading.innerHTML = heading;
     // }
    }
    showSummaryButton(pid);
  }
}*/

  function eigene_zeichnung_click(value, fcount, pid, element) {
    if ($(element).hasClass('active') == false) {
      removeAllValues(pid);
      let fingerabItems = element.closest('.list').querySelectorAll('li');
      fingerabItems.forEach(function (li) {
        // Check if the 'li' has the 'active' class
        if (li.classList.contains('active')) {
          // Remove the 'active' class
          li.classList.remove('active');
        }
      });

      if (fcount) {
        var parent_counter = $('.product_' + pid).attr('data-stepone-count');
        var new_counter = parseInt(parent_counter) + parseInt(fcount);
        $('.product_' + pid).val(new_counter);

        let motivelist = element.closest('.motivelist');
        let fileRows = motivelist.querySelectorAll('.file_upload .row');
        let file_upload = motivelist.querySelector('.file_upload');
        if (file_upload) {
          file_upload.style.display = 'block';
        }
        fileRows.forEach(function (row) {
          if (row.getAttribute('data-count') === fcount.toString()) {
            row.style.display = 'block';
            row.querySelectorAll('.col').forEach(function (div) {
              let inputf = div.querySelector('input');
              if (inputf) {
                inputf.removeAttribute('disabled');
              }
            });
          } else {
            row.style.display = 'none';
          }
        });
      }
      // Add 'active' class to the clicked element (li)
      element.classList.add('active');
      let parenttab = element.closest('.parent-tab-content');
      const tabindex = parenttab.getAttribute('data-tab-index');
      let parenttabs = element.closest('.parents-tab-contents');

      let select_Geburtsblume_box = parenttabs.querySelector(
        `.option-summary #motiv_summary_${tabindex} .selected_summary .select_Geburtsblume_box`
      );
      if (select_Geburtsblume_box) {
        // Clear previous content (optional, if you want to replace)
        select_Geburtsblume_box.innerHTML = '';
      }
      let fileupload_html = parenttabs.querySelector(
        `.option-summary #motiv_summary_${tabindex} .selected_summary .fileupload_html`
      );
      if (fileupload_html) {
        fileupload_html.innerHTML = '';
      }
      let summaryContainer = parenttabs.querySelector(
        `.option-summary #motiv_summary_${tabindex} .selected_summary .select_file_box`
      );
      if (summaryContainer) {
        summaryContainer.innerHTML = '';
        summaryContainer.innerHTML += element.innerHTML;
      }
      showSummaryButton(pid);
    }
  }

  function kindersymbole_click(value, fcount, pid, element) {
    if ($(element).hasClass('active') == false) {
      removeAllValues(pid);
      let initialenItems = element.closest('.list').querySelectorAll('li');
      initialenItems.forEach(function (li) {
        // Check if the 'li' has the 'active' class
        if (li.classList.contains('active')) {
          // Remove the 'active' class
          li.classList.remove('active');
        }
      });
      element.classList.add('active');
      // Find the closest h3 within .motivelist and get its text content

      let parenttab = element.closest('.parent-tab-content');
      const tabindex = parenttab.getAttribute('data-tab-index');
      let parenttabs = element.closest('.parents-tab-contents');

      let select_Geburtsblume_box = parenttabs.querySelector(
        `.option-summary #motiv_summary_${tabindex} .selected_summary .select_Geburtsblume_box`
      );
      if (select_Geburtsblume_box) {
        // Clear previous content (optional, if you want to replace)
        select_Geburtsblume_box.innerHTML = '';
      }

      let select_file_box = parenttabs.querySelector(
        `.option-summary #motiv_summary_${tabindex} .selected_summary .select_file_box`
      );
      if (select_file_box) {
        select_file_box.innerHTML = '';
        select_file_box.innerHTML += element.innerHTML;
      }
      // Find the closest h3 within .motivelist and get its text content
      const heading = element.closest('.motivelist').querySelector('.motivelist-title')?.textContent;
      if (heading != null) {
        // Update the innerHTML of the h3 inside .selected_summary with the heading text
        const selectedSummaryHeading = parenttabs.querySelector(
          `.option-summary .selected_motiv_option#motiv_summary_${tabindex} .selected_summary > .heading`
        );
        // if (selectedSummaryHeading) {
        //  selectedSummaryHeading.innerHTML = heading;
        // }
      }
      showSummaryButton(pid);
    }
  }

  function kindersternzeichen_click(value, fcount, pid, element) {
    if ($(element).hasClass('active') == false) {
      removeAllValues(pid);
      let initialenItems = element.closest('.list').querySelectorAll('li');
      initialenItems.forEach(function (li) {
        // Check if the 'li' has the 'active' class
        if (li.classList.contains('active')) {
          // Remove the 'active' class
          li.classList.remove('active');
        }
      });
      element.classList.add('active');
      // Find the closest h3 within .motivelist and get its text content

      let parenttab = element.closest('.parent-tab-content');
      const tabindex = parenttab.getAttribute('data-tab-index');
      let parenttabs = element.closest('.parents-tab-contents');

      let select_Geburtsblume_box = parenttabs.querySelector(
        `.option-summary #motiv_summary_${tabindex} .selected_summary .select_Geburtsblume_box`
      );
      if (select_Geburtsblume_box) {
        // Clear previous content (optional, if you want to replace)
        select_Geburtsblume_box.innerHTML = '';
      }

      let select_file_box = parenttabs.querySelector(
        `.option-summary #motiv_summary_${tabindex} .selected_summary .select_file_box`
      );
      if (select_file_box) {
        select_file_box.innerHTML = '';
        select_file_box.innerHTML += element.innerHTML;
      }
      // Find the closest h3 within .motivelist and get its text content
      const heading = element.closest('.motivelist').querySelector('.motivelist-title')?.textContent;
      if (heading != null) {
        // Update the innerHTML of the h3 inside .selected_summary with the heading text
        const selectedSummaryHeading = parenttabs.querySelector(
          `.option-summary .selected_motiv_option#motiv_summary_${tabindex} .selected_summary > .heading`
        );
        // if (selectedSummaryHeading) {
        //  selectedSummaryHeading.innerHTML = heading;
        // }
      }
      showSummaryButton(pid);
    }
  }

  function initialen_click(value, fcount, pid, element) {
    if ($(element).hasClass('active') == false) {
      removeAllValues(pid);
      let initialenItems = element.closest('.list').querySelectorAll('li');
      initialenItems.forEach(function (li) {
        // Check if the 'li' has the 'active' class
        if (li.classList.contains('active')) {
          // Remove the 'active' class
          li.classList.remove('active');
        }
      });

      if (fcount) {
        let motivelist = element.closest('.motivelist');
        let inputElement = motivelist.querySelector('.engraving-text > textarea');
        let fontSelection = motivelist.querySelector('.font-selection');
        if (fontSelection) {
          var parent_counter = $('.product_' + pid).attr('data-stepone-count');
          var new_counter = parseInt(parent_counter) + parseInt(1);
          $('.product_' + pid).val(new_counter);
          fontSelection.style.display = 'block';
        }

        if (inputElement) {
          var parent_counter = $('.product_' + pid).val();
          var new_counter = parseInt(parent_counter) + parseInt(1);
          $('.product_' + pid).val(new_counter);

          inputElement.value = ''; // Clear the input value
          var fcount_num = Number(fcount.split('_')[0]);
          inputElement.setAttribute('maxlength', fcount_num);
          inputElement.disabled = false;
        }
      }
      // Add 'active' class to the clicked element (li)
      element.classList.add('active');

      let parenttab = element.closest('.parent-tab-content');
      const tabindex = parenttab.getAttribute('data-tab-index');
      let parenttabs = element.closest('.parents-tab-contents');

      let select_Geburtsblume_box = parenttabs.querySelector(
        `.option-summary #motiv_summary_${tabindex} .selected_summary .select_Geburtsblume_box`
      );
      if (select_Geburtsblume_box) {
        // Clear previous content (optional, if you want to replace)
        select_Geburtsblume_box.innerHTML = '';
      }

      let select_file_box = parenttabs.querySelector(
        `.option-summary #motiv_summary_${tabindex} .selected_summary .select_file_box`
      );
      if (select_file_box) {
        select_file_box.innerHTML = '';
        select_file_box.innerHTML += element.innerHTML;
      }
      let initialenMain = element.closest('.motivelist').querySelectorAll('.font_lists li');
      if (initialenMain.length > 0) {
        initialenMain[0].click();
      }
      showSummaryButton(pid);
    }
  }
  function grafiken_click(value, fcount, pid, element) {
    if ($(element).hasClass('active') == false) {
      removeAllValues(pid);
      let fingerabItems = element.closest('.list').querySelectorAll('li');
      fingerabItems.forEach(function (li) {
        // Check if the 'li' has the 'active' class
        if (li.classList.contains('active')) {
          // Remove the 'active' class
          li.classList.remove('active');
        }
      });

      if (fcount) {
        var parent_counter = $('.product_' + pid).attr('data-stepone-count');
        var new_counter = parseInt(parent_counter) + parseInt(fcount);
        $('.product_' + pid).val(new_counter);

        let motivelist = element.closest('.motivelist');
        let fileRows = motivelist.querySelectorAll('.file_upload .row');
        let file_upload = motivelist.querySelector('.file_upload');
        if (file_upload) {
          file_upload.style.display = 'block';
        }
        fileRows.forEach(function (row) {
          if (row.getAttribute('data-count') === fcount.toString()) {
            row.style.display = 'block';
            row.querySelectorAll('.col').forEach(function (div) {
              let inputf = div.querySelector('input');
              if (inputf) {
                inputf.removeAttribute('disabled');
              }
            });
          } else {
            row.style.display = 'none';
          }
        });
      }
      // Add 'active' class to the clicked element (li)
      element.classList.add('active');
      let parenttab = element.closest('.parent-tab-content');
      const tabindex = parenttab.getAttribute('data-tab-index');
      let parenttabs = element.closest('.parents-tab-contents');

      let select_Geburtsblume_box = parenttabs.querySelector(
        `.option-summary #motiv_summary_${tabindex} .selected_summary .select_Geburtsblume_box`
      );
      if (select_Geburtsblume_box) {
        // Clear previous content (optional, if you want to replace)
        select_Geburtsblume_box.innerHTML = '';
      }

      let fileupload_html = parenttabs.querySelector(
        `.option-summary #motiv_summary_${tabindex} .selected_summary .fileupload_html`
      );
      if (fileupload_html) {
        fileupload_html.innerHTML = '';
      }
      let summaryContainer = parenttabs.querySelector(
        `.option-summary #motiv_summary_${tabindex} .selected_summary .select_file_box`
      );
      if (summaryContainer) {
        summaryContainer.innerHTML = '';
        summaryContainer.innerHTML += element.innerHTML;
      }
      showSummaryButton(pid);
    }
  }
  function eigene_handschrift_click(value, fcount, pid, element) {
    if ($(element).hasClass('active') == false) {
      removeAllValues(pid);
      let fingerabItems = element.closest('.list').querySelectorAll('li');
      fingerabItems.forEach(function (li) {
        // Check if the 'li' has the 'active' class
        if (li.classList.contains('active')) {
          // Remove the 'active' class
          li.classList.remove('active');
        }
      });

      if (fcount) {
        var parent_counter = $('.product_' + pid).attr('data-stepone-count');
        var new_counter = parseInt(parent_counter) + parseInt(fcount);
        $('.product_' + pid).val(new_counter);

        let motivelist = element.closest('.motivelist');
        let fileRows = motivelist.querySelectorAll('.file_upload .row');
        let file_upload = motivelist.querySelector('.file_upload');
        if (file_upload) {
          file_upload.style.display = 'block';
        }
        fileRows.forEach(function (row) {
          if (row.getAttribute('data-count') === fcount.toString()) {
            row.style.display = 'block';
            row.querySelectorAll('.col').forEach(function (div) {
              let inputf = div.querySelector('input');
              if (inputf) {
                inputf.removeAttribute('disabled');
              }
            });
          } else {
            row.style.display = 'none';
          }
        });
      }
      // Add 'active' class to the clicked element (li)
      element.classList.add('active');

      let parenttab = element.closest('.parent-tab-content');
      const tabindex = parenttab.getAttribute('data-tab-index');
      let parenttabs = element.closest('.parents-tab-contents');

      let select_Geburtsblume_box = parenttabs.querySelector(
        `.option-summary #motiv_summary_${tabindex} .selected_summary .select_Geburtsblume_box`
      );
      if (select_Geburtsblume_box) {
        // Clear previous content (optional, if you want to replace)
        select_Geburtsblume_box.innerHTML = '';
      }

      let fileupload_html = parenttabs.querySelector(
        `.option-summary #motiv_summary_${tabindex} .selected_summary .fileupload_html`
      );
      if (fileupload_html) {
        fileupload_html.innerHTML = '';
      }
      let summaryContainer = parenttabs.querySelector(
        `.option-summary #motiv_summary_${tabindex} .selected_summary .select_file_box`
      );
      if (summaryContainer) {
        summaryContainer.innerHTML = '';
        summaryContainer.innerHTML += element.innerHTML;
      }
      showSummaryButton(pid);
    }
  }

  function bild_text_click(value, fcount, pid, element) {
    if ($(element).hasClass('active') == false) {
      removeAllValues(pid);
      let fingerabItems = element.closest('.list').querySelectorAll('li');
      fingerabItems.forEach(function (li) {
        // Check if the 'li' has the 'active' class
        if (li.classList.contains('active')) {
          // Remove the 'active' class
          li.classList.remove('active');
        }
      });

      var total_fields_required = 0;
      if (fcount) {
        total_fields_required = parseInt(total_fields_required) + parseInt(fcount);
        var parent_counter = $('.product_' + pid).attr('data-stepone-count');
        var new_counter = parseInt(parent_counter) + parseInt(fcount);
        $('.product_' + pid).val(new_counter);

        let motivelist = element.closest('.motivelist');
        let fileRows = motivelist.querySelectorAll('.file_upload .row');
        let file_upload = motivelist.querySelector('.file_upload');
        if (file_upload) {
          file_upload.style.display = 'block';
        }
        let fontSelection = motivelist.querySelector('.font-selection');
        if (fontSelection) {
          total_fields_required = parseInt(total_fields_required) + parseInt(1);
          var parent_counter = $('.product_' + pid).val();
          var new_counter = parseInt(parent_counter) + parseInt(1);
          $('.product_' + pid).val(new_counter);

          fontSelection.style.display = 'block';
        }
        let inputElement = motivelist.querySelector('.engraving-text > input');
        if (inputElement) {
          total_fields_required = parseInt(total_fields_required) + parseInt(1);
          inputElement.disabled = false;
        }
        fileRows.forEach(function (row) {
          if (row.getAttribute('data-count') === fcount.toString()) {
            row.style.display = 'block';
            row.querySelectorAll('.col').forEach(function (div) {
              let inputf = div.querySelector('input');
              if (inputf) {
                inputf.removeAttribute('disabled');
              }
            });
          } else {
            row.style.display = 'none';
          }
        });
      }

      var parent_counter = $('.product_' + pid).attr('data-stepone-count');
      var new_counter = parseInt(parent_counter) + parseInt(total_fields_required);
      $('.product_' + pid).val(new_counter);

      // Add 'active' class to the clicked element (li)
      element.classList.add('active');

      let parenttab = element.closest('.parent-tab-content');
      const tabindex = parenttab.getAttribute('data-tab-index');
      let parenttabs = element.closest('.parents-tab-contents');

      let select_Geburtsblume_box = parenttabs.querySelector(
        `.option-summary #motiv_summary_${tabindex} .selected_summary .select_Geburtsblume_box`
      );
      if (select_Geburtsblume_box) {
        // Clear previous content (optional, if you want to replace)
        select_Geburtsblume_box.innerHTML = '';
      }

      let fileupload_html = parenttabs.querySelector(
        `.option-summary #motiv_summary_${tabindex} .selected_summary .fileupload_html`
      );
      if (fileupload_html) {
        fileupload_html.innerHTML = '';
      }
      let summaryContainer = parenttabs.querySelector(
        `.option-summary #motiv_summary_${tabindex} .selected_summary .select_file_box`
      );
      if (summaryContainer) {
        summaryContainer.innerHTML = '';
        summaryContainer.innerHTML += element.innerHTML;
      }
      showSummaryButton(pid);
    }
  }
  function pfotenabdruck_click(value, fcount, pid, element) {
    if ($(element).hasClass('active') == false) {
      removeAllValues(pid);
      let fingerabItems = element.closest('.list').querySelectorAll('li');
      fingerabItems.forEach(function (li) {
        // Check if the 'li' has the 'active' class
        if (li.classList.contains('active')) {
          // Remove the 'active' class
          li.classList.remove('active');
        }
      });
      if (fcount) {
        var parent_counter = $('.product_' + pid).attr('data-stepone-count');
        var new_counter = parseInt(parent_counter) + parseInt(fcount);
        $('.product_' + pid).val(new_counter);

        let motivelist = element.closest('.motivelist');
        let fileRows = motivelist.querySelectorAll('.file_upload .row');
        let file_upload = motivelist.querySelector('.file_upload');
        if (file_upload) {
          file_upload.style.display = 'block';
        }
        fileRows.forEach(function (row) {
          if (row.getAttribute('data-count') === fcount.toString()) {
            row.style.display = 'block';
            row.querySelectorAll('.col').forEach(function (div) {
              let inputf = div.querySelector('input');
              if (inputf) {
                inputf.removeAttribute('disabled');
              }
            });
          } else {
            row.style.display = 'none';
          }
        });
      }
      // Add 'active' class to the clicked element (li)
      element.classList.add('active');

      let parenttab = element.closest('.parent-tab-content');
      const tabindex = parenttab.getAttribute('data-tab-index');
      let parenttabs = element.closest('.parents-tab-contents');

      let select_Geburtsblume_box = parenttabs.querySelector(
        `.option-summary #motiv_summary_${tabindex} .selected_summary .select_Geburtsblume_box`
      );
      if (select_Geburtsblume_box) {
        // Clear previous content (optional, if you want to replace)
        select_Geburtsblume_box.innerHTML = '';
      }

      let summaryContainer = parenttabs.querySelector(
        `.option-summary #motiv_summary_${tabindex} .selected_summary .select_file_box`
      );

      if (summaryContainer) {
        summaryContainer.innerHTML = '';
        summaryContainer.innerHTML += element.innerHTML;
      }
      // Find the closest h3 within .motivelist and get its text content
      const heading = element.closest('.motivelist').querySelector('.motivelist-title')?.textContent;
      if (heading != null) {
        // Update the innerHTML of the h3 inside .selected_summary with the heading text
        const selectedSummaryHeading = parenttabs.querySelector(
          `.option-summary .selected_motiv_option#motiv_summary_${tabindex} .selected_summary > .heading`
        );
        // if (selectedSummaryHeading) {
        //  selectedSummaryHeading.innerHTML = heading;
        // }
      }
      showSummaryButton(pid);
    }
  }

  function fingerabdruck_click(value, fcount, pid, element) {
    if ($(element).hasClass('active') == false) {
      removeAllValues(pid);
      let fingerabItems = element.closest('.list').querySelectorAll('li');
      fingerabItems.forEach(function (li) {
        // Check if the 'li' has the 'active' class
        if (li.classList.contains('active')) {
          // Remove the 'active' class
          li.classList.remove('active');
        }
      });

      if (fcount) {
        var parent_counter = $('.product_' + pid).attr('data-stepone-count');
        var new_counter = parseInt(parent_counter) + parseInt(fcount);
        $('.product_' + pid).val(new_counter);

        let motivelist = element.closest('.motivelist');
        let fileRows = motivelist.querySelectorAll('.file_upload .row');
        let file_upload = motivelist.querySelector('.file_upload');
        if (file_upload) {
          file_upload.style.display = 'block';
        }
        fileRows.forEach(function (row) {
          if (row.getAttribute('data-count') === fcount.toString()) {
            row.style.display = 'block';
            row.querySelectorAll('.col').forEach(function (div) {
              let inputf = div.querySelector('input');
              if (inputf) {
                inputf.removeAttribute('disabled');
              }
            });
          } else {
            row.style.display = 'none';
          }
        });
      }
      // Add 'active' class to the clicked element (li)
      element.classList.add('active');

      let parenttab = element.closest('.parent-tab-content');
      const tabindex = parenttab.getAttribute('data-tab-index');
      let parenttabs = element.closest('.parents-tab-contents');

      let select_Geburtsblume_box = parenttabs.querySelector(
        `.option-summary #motiv_summary_${tabindex} .selected_summary .select_Geburtsblume_box`
      );
      if (select_Geburtsblume_box) {
        // Clear previous content (optional, if you want to replace)
        select_Geburtsblume_box.innerHTML = '';
      }

      let summaryContainer = parenttabs.querySelector(
        `.option-summary #motiv_summary_${tabindex} .selected_summary .select_file_box`
      );

      if (summaryContainer) {
        summaryContainer.innerHTML = '';
        summaryContainer.innerHTML += element.innerHTML;
      }
      showSummaryButton(pid);
    }
  }

  function fu_abdruck_click(value, fcount, pid, element) {
    if ($(element).hasClass('active') == false) {
      removeAllValues(pid);
      let fingerabItems = element.closest('.list').querySelectorAll('li');
      fingerabItems.forEach(function (li) {
        // Check if the 'li' has the 'active' class
        if (li.classList.contains('active')) {
          // Remove the 'active' class
          li.classList.remove('active');
        }
      });

      if (fcount) {
        var parent_counter = $('.product_' + pid).attr('data-stepone-count');
        var new_counter = parseInt(parent_counter) + parseInt(fcount);
        $('.product_' + pid).val(new_counter);

        let motivelist = element.closest('.motivelist');
        let fileRows = motivelist.querySelectorAll('.file_upload .row');
        let file_upload = motivelist.querySelector('.file_upload');
        if (file_upload) {
          file_upload.style.display = 'block';
        }
        fileRows.forEach(function (row) {
          if (row.getAttribute('data-count') === fcount.toString()) {
            row.style.display = 'block';
            row.querySelectorAll('.col').forEach(function (div) {
              let inputf = div.querySelector('input');
              if (inputf) {
                inputf.removeAttribute('disabled');
              }
            });
          } else {
            row.style.display = 'none';
          }
        });
      }
      // Add 'active' class to the clicked element (li)
      element.classList.add('active');

      let parenttab = element.closest('.parent-tab-content');
      const tabindex = parenttab.getAttribute('data-tab-index');
      let parenttabs = element.closest('.parents-tab-contents');
      let select_Geburtsblume_box = parenttabs.querySelector(
        `.option-summary #motiv_summary_${tabindex} .selected_summary .select_Geburtsblume_box`
      );
      if (select_Geburtsblume_box) {
        // Clear previous content (optional, if you want to replace)
        select_Geburtsblume_box.innerHTML = '';
      }

      let summaryContainer = parenttabs.querySelector(
        `.option-summary #motiv_summary_${tabindex} .selected_summary .select_file_box`
      );
      if (summaryContainer) {
        summaryContainer.innerHTML = '';
        summaryContainer.innerHTML += element.innerHTML;
      }
      showSummaryButton(pid);
    }
  }

  function nasenabdruck_click(value, fcount, pid, element) {
    if ($(element).hasClass('active') == false) {
      removeAllValues(pid);
      let fingerabItems = element.closest('.list').querySelectorAll('li');
      fingerabItems.forEach(function (li) {
        // Check if the 'li' has the 'active' class
        if (li.classList.contains('active')) {
          // Remove the 'active' class
          li.classList.remove('active');
        }
      });

      if (fcount) {
        var parent_counter = $('.product_' + pid).attr('data-stepone-count');
        var new_counter = parseInt(parent_counter) + parseInt(fcount);
        $('.product_' + pid).val(new_counter);

        let motivelist = element.closest('.motivelist');
        let fileRows = motivelist.querySelectorAll('.file_upload .row');
        let file_upload = motivelist.querySelector('.file_upload');
        if (file_upload) {
          file_upload.style.display = 'block';
        }
        fileRows.forEach(function (row) {
          if (row.getAttribute('data-count') === fcount.toString()) {
            row.style.display = 'block';
            row.querySelectorAll('.col').forEach(function (div) {
              let inputf = div.querySelector('input');
              if (inputf) {
                inputf.removeAttribute('disabled');
              }
            });
          } else {
            row.style.display = 'none';
          }
        });
      }
      // Add 'active' class to the clicked element (li)
      element.classList.add('active');

      let parenttab = element.closest('.parent-tab-content');
      const tabindex = parenttab.getAttribute('data-tab-index');
      let parenttabs = element.closest('.parents-tab-contents');
      let select_Geburtsblume_box = parenttabs.querySelector(
        `.option-summary #motiv_summary_${tabindex} .selected_summary .select_Geburtsblume_box`
      );
      if (select_Geburtsblume_box) {
        // Clear previous content (optional, if you want to replace)
        select_Geburtsblume_box.innerHTML = '';
      }

      let summaryContainer = parenttabs.querySelector(
        `.option-summary #motiv_summary_${tabindex} .selected_summary .select_file_box`
      );

      if (summaryContainer) {
        summaryContainer.innerHTML = '';
        summaryContainer.innerHTML += element.innerHTML;
      }
      showSummaryButton(pid);
    }
  }

  function handabdruck_click(value, fcount, pid, element) {
    if ($(element).hasClass('active') == false) {
      removeAllValues(pid);
      let fingerabItems = element.closest('.list').querySelectorAll('li');
      fingerabItems.forEach(function (li) {
        // Check if the 'li' has the 'active' class
        if (li.classList.contains('active')) {
          // Remove the 'active' class
          li.classList.remove('active');
        }
      });

      if (fcount) {
        var parent_counter = $('.product_' + pid).attr('data-stepone-count');
        var new_counter = parseInt(parent_counter) + parseInt(fcount);
        $('.product_' + pid).val(new_counter);

        let motivelist = element.closest('.motivelist');
        let fileRows = motivelist.querySelectorAll('.file_upload .row');
        let file_upload = motivelist.querySelector('.file_upload');
        if (file_upload) {
          file_upload.style.display = 'block';
        }
        fileRows.forEach(function (row) {
          if (row.getAttribute('data-count') === fcount.toString()) {
            row.style.display = 'block';
            row.querySelectorAll('.col').forEach(function (div) {
              let inputf = div.querySelector('input');
              if (inputf) {
                inputf.removeAttribute('disabled');
              }
            });
          } else {
            row.style.display = 'none';
          }
        });
      }
      // Add 'active' class to the clicked element (li)
      element.classList.add('active');

      let parenttab = element.closest('.parent-tab-content');
      const tabindex = parenttab.getAttribute('data-tab-index');
      let parenttabs = element.closest('.parents-tab-contents');
      let select_Geburtsblume_box = parenttabs.querySelector(
        `.option-summary #motiv_summary_${tabindex} .selected_summary .select_Geburtsblume_box`
      );
      if (select_Geburtsblume_box) {
        // Clear previous content (optional, if you want to replace)
        select_Geburtsblume_box.innerHTML = '';
      }

      let summaryContainer = parenttabs.querySelector(
        `.option-summary #motiv_summary_${tabindex} .selected_summary .select_file_box`
      );

      if (summaryContainer) {
        summaryContainer.innerHTML = '';
        summaryContainer.innerHTML += element.innerHTML;
      }
      showSummaryButton(pid);
    }
  }

  function goToPreviousStep(tabId, element) {
    // Logic to move to the next step
    /*let tabsContainer = element.closest('.tabs-container');
    tabsContainer.querySelectorAll('ul.tabs li').forEach((li, index, allLis) => {
    if (li.classList.contains('bold_bar')) {
        // If current li has the 'bold_bar' class, remove from the next li
        if (index + 1 < allLis.length) {
            allLis[index + 1].classList.remove('bold_bar');
        }
    } else {
        // If current li doesn't have the 'tabId' class, remove 'bold_bar'
        //li.classList.remove('bold_bar');
    }
  });*/
    let $tabsContainer = $(element).closest('.tabs-container');
    $tabsContainer.find('ul.tabs li').each(function (index, li) {
      if ($(li).hasClass(tabId)) {
        // If the current li has the 'bold_bar' class, remove from the next li
        let $nextLi = $(li).next();
        if ($nextLi.length) {
          $nextLi.removeClass('bold_bar');
        }
      }
    });
    showparentTabContent(tabId, element);
    //$("#product_gravur__Wrapper").animate({ scrollTop: 0 }, "slow");
    var target = document.getElementById('product_gravur__Wrapper');
    smoothScroll(target, 1200, 50);
  }

  function goToNextStep(tabId, element) {
    let gravurart = element.closest('.parent-tab-content');
    let parenttabs = element.closest('.parents-tab-contents');
    const tabindex = gravurart.getAttribute('data-tab-index');
    if (gravurart && gravurart.querySelector('.gravurart li.active')) {
      // Logic to move to the next step
      let lastStep = parenttabs.querySelector(`#tab-content-abschliessen-${tabindex}`);
      //console.log('lastStep before check:', lastStep);
      if (lastStep) {
        // Hide all "a.gravurart" elements
        lastStep.querySelectorAll('a.gravurart').forEach((link) => {
          link.style.display = 'block';
        });
        // Show all "a.no-gravurart" elements
        lastStep.querySelectorAll('a.no-gravurart').forEach((link) => {
          link.style.display = 'none';
        });
      }
      showparentTabContent(tabId, element);
    }
    var target = document.getElementById('product_gravur__Wrapper');
    smoothScroll(target, 1200, 50);
    // var target = document.getElementById("product_gravur__Wrapper");
    // target.scrollIntoView({ behavior: "smooth", block: "start" });
    //$("#product_gravur__Wrapper").animate({ scrollTop: 0 }, "slow");
    // let wrapper = document.getElementById("product_gravur__Wrapper");
    //   let target = document.querySelector(".gravuroptions");

    //   if (wrapper && target) {
    //       wrapper.scrollTo({
    //           top: target.offsetTop - wrapper.offsetTop,
    //           behavior: "smooth"
    //       });
    //   }
  }

  function goToNextStep1(tabId, element) {
    let gravurart = element.closest('.parent-tab-content');
    const tabindex = gravurart.getAttribute('data-tab-index');
    let parenttabs = element.closest('.parents-tab-contents');
    let lastStep = parenttabs.querySelector(`#tab-content-abschliessen-${tabindex}`);
    //console.log('lastStep before check:', lastStep);
    if (lastStep) {
      // Loop through all matching elements and hide them
      lastStep.querySelectorAll('.selected_summary.less_spacing').forEach(function (element) {
        element.style.display = 'block';
      });
    }
    let parentTab = $(element).closest('.parent-tab-content'); // Find the closest parent tab content
    let hasError = false; // Track if any validation fails
    parentTab.find('.motivelist:visible').each(function () {
      if ($(this).find('.engraving-text').length > 0) {
        let motiveText = $(this).find('.engraving-text textarea.motive_text'); // Find input inside current motivelist
        if (motiveText.val().trim() === '') {
          // Check if input is empty
          alert('Pflichtfeld: Bitte Motivtext eingeben.');
          motiveText.focus(); // Focus the first empty input field
          hasError = true; // Set error flag
          return false; // Exit loop early on first error
        }
      }
      let fileDiv = $(this).find('.file_upload'); // Find .file_upload
      if (fileDiv.length > 0) {
        if (fileDiv.is(':visible')) {
          // Check if .file_upload is visible
          fileDiv.find('.file_row:visible').each(function () {
            // Loop through visible .file_row
            $(this)
              .find('.col')
              .each(function () {
                let fileInput = $(this).find('input[type="file"]'); // Find file input inside .file_row
                if (fileInput.length && fileInput[0].files.length === 0) {
                  // Check if file is selected
                  alert('Erforderlich: Bitte laden Sie eine Datei hoch.'); // Show alert
                  fileInput.focus(); // Focus on the file input field
                  hasError = true;
                  return false; // Stop loop on first error
                }
              });
          });
        }
      }
    });
    if (hasError) {
      return false; // Stop function if validation failed
    }
    // var target = document.getElementById("product_gravur__Wrapper");
    // target.scrollIntoView({ behavior: "smooth", block: "start" });

    showparentTabContent(tabId, element);
    // let wrapper = document.getElementById("product_gravur__Wrapper");
    //   let target = document.querySelector(".gravuroptions");

    //   if (wrapper && target) {
    //       wrapper.scrollTo({
    //           top: target.offsetTop - wrapper.offsetTop,
    //           behavior: "smooth"
    //       });
    //   }
    //$("#product_gravur__Wrapper").animate({ scrollTop: 0 }, "slow");
    let $tabsContainer = $(element).closest('.tabs-container');
    $tabsContainer.find('ul.tabs li').each(function (index, li) {
      if (!$(li).hasClass(tabId)) {
        if (!$(li).hasClass('bold_bar')) {
          $(li).addClass('bold_bar');
        }
      }
    });
    var target = document.getElementById('product_gravur__Wrapper');
    smoothScroll(target, 1200, 50);
  }

  function goToFinalStep(tabId, element) {
    let $tabsContainer = $(element).closest('.tabs-container');
    $tabsContainer.find('ul.tabs li').each(function (index, li) {
      if (!$(li).hasClass('bold_bar') && !$(li).hasClass(tabId)) {
        // If the current li has the 'bold_bar' class, remove from the next li
        $(li).addClass('bold_bar');
      }
    });

    let gravurart = element.closest('.parent-tab-content');
    let parenttabs = element.closest('.parents-tab-contents');
    const tabindex = gravurart.getAttribute('data-tab-index');
    //console.log('lastStep index'+tabindex);
    if (gravurart && gravurart.querySelector('.gravurart li.active')) {
      // Logic to move to the next step
      let lastStep = parenttabs.querySelector(`#tab-content-abschliessen-${tabindex}`);

      //console.log('lastStep before check:', lastStep);
      if (lastStep) {
        // Loop through all matching elements and hide them
        lastStep.querySelectorAll('.selected_summary.less_spacing').forEach(function (element) {
          element.style.display = 'none';
        });
        // Hide all "a.gravurart" elements
        lastStep.querySelectorAll('a.gravurart').forEach((link) => {
          link.style.display = 'none';
        });
        // Show all "a.no-gravurart" elements
        lastStep.querySelectorAll('a.no-gravurart').forEach((link) => {
          link.style.display = 'block';
        });
      }
      showparentTabContent(tabId, element);
    }
    var target = document.getElementById('product_gravur__Wrapper');
    smoothScroll(target, 1200, 50);
  }
  function removeEngravingSelection(value, pid, element) {
    removeAllValues(pid);
    $('.tab-content-' + pid + ' .gravurart .items').removeClass('active');
    $(element).addClass('active');
    $('.first-step-button-' + pid).css('display', 'none');
    $('.all_total_values_count.product_' + pid).val(1);
    $('.all_total_values_count.product_' + pid).attr('data-price', 0);
    $('.all_total_values_count.product_' + pid).attr('data-stepone-count', 0);

    let parenttab = element.closest('.parent-tab-content');
    const tabindex = parenttab.getAttribute('data-tab-index');
    let parenttabs = element.closest('.parents-tab-contents');
    let summaryContainer = parenttabs.querySelector(`.option-summary #gravurart_summary_${tabindex} .selected_summary`);

    if (summaryContainer) {
      summaryContainer.innerHTML = '';
      summaryContainer.innerHTML += element.innerHTML;
    }

    let inputbox_htmlC = parenttabs.querySelector(`.option-summary #motiv_summary_${tabindex} .inputbox_html`);
    let fonts_html = parenttabs.querySelector(`.option-summary #motiv_summary_${tabindex} .fonts_html`);
    let select_file_box = parenttabs.querySelector(`.option-summary #motiv_summary_${tabindex} .select_file_box`);
    let fileupload_html = parenttabs.querySelector(`.option-summary #motiv_summary_${tabindex} .fileupload_html`);

    if (fileupload_html) {
      fileupload_html.innerHTML = '';
    }
    if (select_file_box) {
      // Clear the existing content
      select_file_box.innerHTML = '';
    }
    // Check if the summary container exists
    if (fonts_html) {
      // Clear the existing content
      fonts_html.innerHTML = '';
    }
    if (inputbox_htmlC) {
      // Clear the existing content
      inputbox_htmlC.innerHTML = '';
    }

    let parenttabcontent = element.closest('.parent-tab-content');
    if (parenttabcontent) {
      const nextbtn = parenttabcontent.querySelector('.step-next-btn');
      if (nextbtn && nextbtn.classList.contains('active')) {
        nextbtn.classList.remove('active');
      }
      const laststepbtn = parenttabcontent.querySelector('.step-last-btn');
      if (laststepbtn && !laststepbtn.classList.contains('active')) {
        laststepbtn.classList.add('active');
      }
    }
  }

  function selectgravurart(value, pid, element) {
    $('.parent_product_id_' + pid).removeClass('step_completed');
    $('.parent_product_id_' + pid).addClass('step_in_process');
    console.log('length' + $('.all_total_values_count.product_' + pid).length);
    var originalPrice = $('.all_total_values_count.product_' + pid).attr('data-original-price')
    $('.all_total_values_count.product_' + pid).attr('data-price', originalPrice);
    $(this).addClass('picked');
    $('.first-step-button-' + pid).css('display', 'initial');
    //if (value == 'Freier Text' || value == 'Koordinaten' || value == 'Vertikaler Text') {
    if (
      value == 'Freier Text' ||
      value == 'Koordinaten' ||
      value == 'Vertikaler Text' ||
      value == 'Geburtsuhr' ||
      value == 'Geburtsdaten' ||
      value == 'Bild + Text'
    ) {
      $('.product_' + pid).val(3);
      $('.product_' + pid).attr('data-stepone-count', 3);
    } else {
      $('.product_' + pid).val(2);
      $('.product_' + pid).attr('data-stepone-count', 2);
    }
    // Find the closest '.tabs-container' ancestor
    let tabsContainer = element.closest('.tabs-container');
    let parenttab = element.closest('.parent-tab-content');
    const tabindex = parenttab.getAttribute('data-tab-index');

    $('#tab-content-motiv-' + tabindex + ' .items').removeClass('active');
    $('#tab-content-motiv-' + tabindex + ' input[type="file"].file_upload').val('');
    $('#tab-content-motiv-' + tabindex + ' input[type="text"]').val('');

    if (parenttab) {
      const nextbtn = parenttab.querySelector('.step-next-btn');
      if (nextbtn && !nextbtn.classList.contains('active')) {
        nextbtn.classList.add('active');
      }
      const laststepbtn = parenttab.querySelector('.step-last-btn');
      if (laststepbtn && laststepbtn.classList.contains('active')) {
        laststepbtn.classList.remove('active');
      }
    }

    let tabcontent_index = tabsContainer.querySelectorAll(`.parent-tab-content.tab-index-${tabindex} .motivelist`);
    tabcontent_index.forEach(function (item) {
      if (item.getAttribute('data-gravuroption') === value) {
        item.style.display = 'block';
        // Find the first <li class="items"> inside <ul class="list">
        //let firstLi = item.querySelector('ul.list li.items');
        //if (firstLi) {
        //console.log('First <li class="items"> found');
        //firstLi.click(); // Trigger click event
        //}
        //fontlist li
        // let firstLiF = item.querySelector('ul.font_lists li.items');
        //if (firstLiF) {
        //console.log('First <li class="items"> found');
        //firstLiF.click(); // Trigger click event
        //}
      } else {
        item.style.display = 'none';
      }
    });

    // Select all 'li' elements inside the 'ul' in the '.tabs-container'
    let listItems = tabsContainer.querySelectorAll('ul.tabs li');
    if (value == 'Keine Gravur') {
      // Loop through each 'li' element
      listItems.forEach(function (li) {
        // Check if the 'li' does not have the 'active' class
        if (!li.classList.contains('active')) {
          // Add the 'disabled' class
          li.classList.add('disabled');
        }
      });
      let nextBtns = tabsContainer.querySelectorAll('button.step-next-btn');
      nextBtns.forEach(function (nextBtn) {
        //nextBtn.disabled = true;
      });
    } else {
      let nextBtns = tabsContainer.querySelectorAll('button.step-next-btn');
      nextBtns.forEach(function (nextBtn) {
        //nextBtn.disabled = false;
      });
      // Loop through each 'li' element
      listItems.forEach(function (li) {
        // Check if the 'li' does not have the 'active' class
        if (!li.classList.contains('active')) {
          // Add the 'disabled' class
          li.classList.remove('disabled');
        }
      });
    }
    let gravurartItems = element.closest('.gravurart').querySelectorAll('li');
    gravurartItems.forEach(function (li) {
      // Check if the 'li' has the 'active' class
      if (li.classList.contains('active')) {
        // Remove the 'active' class
        li.classList.remove('active');
      }
    });

    // Add 'active' class to the clicked element (li)
    element.classList.add('active');

    // Set the value of the specific default product property
    document.querySelector(`.default_product_property_${pid}`).value = value;

    let parenttabs = element.closest('.parents-tab-contents');
    let summaryContainer = parenttabs.querySelector(`.option-summary #gravurart_summary_${tabindex} .selected_summary`);

    if (summaryContainer) {
      summaryContainer.innerHTML = '';
      summaryContainer.innerHTML += element.innerHTML;
    }
    let inputbox_htmlC = parenttabs.querySelector(`.option-summary #motiv_summary_${tabindex} .inputbox_html`);
    let fonts_html = parenttabs.querySelector(`.option-summary #motiv_summary_${tabindex} .fonts_html`);
    let select_file_box = parenttabs.querySelector(`.option-summary #motiv_summary_${tabindex} .select_file_box`);
    let fileupload_html = parenttabs.querySelector(`.option-summary #motiv_summary_${tabindex} .fileupload_html`);

    if (fileupload_html) {
      fileupload_html.innerHTML = '';
    }
    if (select_file_box) {
      // Clear the existing content
      select_file_box.innerHTML = '';
    }
    // Check if the summary container exists
    if (fonts_html) {
      // Clear the existing content
      fonts_html.innerHTML = '';
    }
    if (inputbox_htmlC) {
      // Clear the existing content
      inputbox_htmlC.innerHTML = '';
    }

    tabcontent_index.forEach(function (item) {
      if (item.getAttribute('data-gravuroption') === value) {
        // Find the first <li class="items"> inside <ul class="list">
        let firstLi = item.querySelector('ul.list li.items');
        if (firstLi) {
          //console.log('First <li class="items"> found');
          firstLi.click(); // Trigger click event
        }
        if (value.toLowerCase() === 'geburtsblumen') {
          // Find the first <li class="items"> inside <ul class="list">
          let firstLis = item.querySelector('ul.geburtsblumen_info li.items');
          if (firstLis) {
            //console.log('First <li class="items"> found');
            firstLis.click(); // Trigger click event
          }
        }
        //fontlist li
        let firstLiF = item.querySelector('ul.font_lists li.items');
        if (firstLiF) {
          //console.log('First <li class="items"> found');
          firstLiF.click(); // Trigger click event
        }
      }
      /*if (item.getAttribute('data-gravuroption') === value) {
       // Find the first <li class="items"> inside <ul class="list">
        let firstLi = item.querySelector('ul.list li.items');
        if (firstLi) {
            //console.log('First <li class="items"> found');
            firstLi.click(); // Trigger click event
        }
      //fontlist li 
      let firstLiF = item.querySelector('ul.font_lists li.items');
        if (firstLiF) {
            //console.log('First <li class="items"> found');
            firstLiF.click(); // Trigger click event
        }
      
    }*/
    });

    showSummaryButton(pid);
  }

  function handleInputtext(element) {
    // Handle the keyup event
    // console.log('Key pressed:', inputElement.value);

    // Find the closest parent tabs container
    let parenttabs = element.closest('.parents-tab-contents');
    let parenttab = element.closest('.parent-tab-content');
    const tabindex = parenttab.getAttribute('data-tab-index');
    // Extract the font-family from the inputElement's style
    // Extract the computed style of the inputElement for the font-family
    let fontfamily = element.style.fontFamily;
    // Find thparent-tab-contente summary container based on the tabindex
    let summaryContainer = parenttabs.querySelector(`.option-summary #motiv_summary_${tabindex} .inputbox_html`);
    let height = element.offsetHeight + 10;
    // Check if the summary container exists
    if (summaryContainer) {
      // Clear the existing content
      summaryContainer.innerHTML = '';
      // Insert the new content with the input value
      // Step 1: Clean each line (remove leading whitespace)
      let cleanedText = element.value
        .split('\n')
        .map((line) => line.trimStart()) // remove leading spaces/tabs
        .join('\n');

      // Step 2: Build HTML with cleaned value (do NOT use 'value' in textarea tag)
      summaryContainer.innerHTML = `
    <div class="_text">
      <textarea name="selectedtext" cols="95" rows="3" readonly style="font-family:${fontfamily}; height:${height}px !important; resize: none;">
${element.value}
      </textarea>
    </div>
  `;
      // Insert the new content with the input value
      /*summaryContainer.innerHTML = `
      <div class="_text">
        <input type="text" name="selectedtext" value="${element.value}" readonly style='font-family:${fontfamily};'>
      </div>
    `;*/
    }
    var pid = $(element).attr('data-product-id');
    showSummaryButton(pid);
  }

  function uploadFile(event, flength, element) {
    const file = event.target.files[0]; // Get the selected file

    let parenttabs = element.closest('.parents-tab-contents');
    let parenttab = element.closest('.parent-tab-content');
    const tabindex = parenttab.getAttribute('data-tab-index');

    const fileUploadHtml = parenttabs.querySelector(`.option-summary #motiv_summary_${tabindex} .fileupload_html`);

    // Find the existing file_${flength} div if any
    const existingFileDiv = fileUploadHtml.querySelector(`.file_${flength}`);

    // Remove the existing file_${flength} div (if it exists) before adding the new one
    if (existingFileDiv) {
      existingFileDiv.remove();
    }

    // Dynamically create the div with class file_${flength} (e.g., file_1 or file_2)
    const dynamicFileDiv = document.createElement('div');
    dynamicFileDiv.classList.add(`file_${flength}`);

    // Check for flength value (1 or 2) and handle accordingly
    if (flength === 1 || flength === 2) {
      // Ensure there's a div with class .file_flength inside the dynamically created div
      let fileFlengthDiv = dynamicFileDiv.querySelector('.file_flength');

      if (!fileFlengthDiv) {
        // If .file_flength div doesn't exist, create it
        fileFlengthDiv = document.createElement('div');
        fileFlengthDiv.classList.add('file_flength');
        dynamicFileDiv.appendChild(fileFlengthDiv);
      }

      if (file) {
        // Append the new file name to the .file_flength div
        const fileNameParagraph = document.createElement('p');
        fileNameParagraph.textContent = `Ausgewählte Datei: ${file.name}`;
        fileFlengthDiv.appendChild(fileNameParagraph);

        // Append the dynamic div to the .fileupload_html div
        fileUploadHtml.appendChild(dynamicFileDiv);
      }
    }

    // Clear the previous content
    // fileUploadHtml.innerHTML = '';

    // Check if a file is selected
    if (file) {
      // Append the new file name to the .fileupload_html div
      /*const fileNameParagraph = document.createElement('p');
      fileNameParagraph.textContent = `Selected file: ${file.name}`;
      fileUploadHtml.appendChild(fileNameParagraph);

      // Handle file preview (for images or PDFs)
      if (file.type.startsWith('image/')) {
        const img = document.createElement('img');
        img.src = URL.createObjectURL(file); // Create object URL for preview
        img.alt = file.name;
        img.style.maxWidth = '300px'; // Optional, to limit preview size
        fileUploadHtml.appendChild(img);
      } else if (file.type === 'application/pdf') {
        const pdfPreview = document.createElement('iframe');
        pdfPreview.src = URL.createObjectURL(file);
        pdfPreview.style.width = '300px';
        pdfPreview.style.height = '200px';
        fileUploadHtml.appendChild(pdfPreview);
      }*/
    } else {
      //fileUploadHtml.innerHTML = '<p>No file selected.</p>';
    }

    var pid = $(element).attr('data-product-id');
    showSummaryButton(pid);
  }

  function showTabContent(gravuroption) {
      // Hide all tab content
      document.querySelectorAll('.tab-content').forEach(function (content) {
        content.style.display = 'none';
      });

      // Remove active class from all tabs
      document.querySelectorAll('.tab-item').forEach(function (tab) {
        tab.classList.remove('active');
      });

      // Show the selected tab content
      document.getElementById(`tab-content-${gravuroption}`).style.display = 'block';

      // Add active class to the clicked tab
      const activeTab = document.querySelector(`.tab-item[onclick="showTabContent('${gravuroption}')"]`);
      if (activeTab) {
        activeTab.classList.add('active');
      }

      // ✅ Update price in .priceinfo
      const priceInfo = document.querySelector('.priceinfo');
      if (priceInfo && activeTab) {
        const template = priceInfo.getAttribute('data-price-template');
        const variantPrice = activeTab.getAttribute('data-variant-price');
        console.log('Updating priceinfo →', { template, variantPrice });
        if (template && variantPrice) {
          priceInfo.innerHTML = template.replace(/\|price\|/g, variantPrice);
        }
      }
  }

  // Default to show first tab content on page load
  document.addEventListener('DOMContentLoaded', function () {
    const firstTab = document.querySelector('.tab-item');
    if (firstTab) {
      firstTab.click();
    }
  });

  function showparentTabContentfirst(tabId) {
    // Hide all tab contents
    /*document.querySelectorAll('.parent-tab-content').forEach(function (content) {
    content.style.display = 'none';
  });

  // Remove 'active' class from all tab items
  document.querySelectorAll('.tab-items').forEach(function (tab) {
    tab.classList.remove('active');
  });*/

    // Show the selected tab content
    document.getElementById(`tab-content-${tabId}`).style.display = 'block';

    // Add 'active' class to the clicked tab
    //event.currentTarget.classList.add('active');
  }

  // Function to handle tab switching
  var showingParentTab = false;
  function showparentTabContent(tabId, element) {
    if (!element) return false;
    // Find the closest '.tabs-container' ancestor
    let tabsContainer = element.closest('.tabs-container');
    if (!tabsContainer) return false;

    // Select all 'li' elements inside the 'ul' in the '.tabs-container'
    let allTabContents = tabsContainer.querySelectorAll('.parents-tab-contents .parent-tab-content');

    // Find all parent tab content elements and hide them
    //const allTabContents = document.querySelectorAll('.parent-tab-content');
    allTabContents.forEach((content) => {
      content.style.display = 'none';
    });

    // Remove 'active' class from all tab items
    const allTabs = tabsContainer.querySelectorAll('.tab-items');
    allTabs.forEach((tab) => {
      tab.classList.remove('active');
    });

    // Show the selected tab content and add 'active' class to the selected tab
    const targetTabContent = document.getElementById(`tab-content-${tabId}`);
    if (targetTabContent) {
      targetTabContent.style.display = 'block';
    }

    const clickedTab = document.querySelector(`[onclick="showparentTabContent('${tabId}')"]`);
    if (clickedTab) {
      clickedTab.classList.add('active');
    }

    let tabItem = tabsContainer.querySelector('.tabs li.tab-items.' + tabId);
    if (tabItem && tabItem !== element && !showingParentTab) {
      showingParentTab = true;
      try {
        tabItem.click();
      } finally {
        showingParentTab = false;
      }
    }

    element.classList.add('active');
    return false;
  }

  // Automatically activate the first tab on page load
  document.addEventListener('DOMContentLoaded', () => {
    // Find all tab containers
    const tabContainers = document.querySelectorAll('.tabs-container');
    tabContainers.forEach((container) => {
      // Activate the first tab and show its content
      const firstTab = container.querySelector('.tab-items');
      if (firstTab) {
        const firstContentId = firstTab.getAttribute('onclick').match(/'(.+?)'/)[1]; // Extract tabId from the onclick attribute
        console.log(firstContentId);
        showparentTabContentfirst(firstContentId); // Activate first tab
      }
    });
  });

  function showSummaryButton(pid) {
    //alert(pid);
    var value_needed = $('.product_' + pid).val();
    var total_values_added = 0;
    $('.tab-content-' + pid + ' .items').each(function () {
      if ($(this).hasClass('active')) {
        total_values_added = parseInt(total_values_added) + parseInt(1);
      }
    });
    $('.tab-content-' + pid + ' .motive_text').each(function () {
      if ($(this).val() != '') {
        total_values_added = parseInt(total_values_added) + parseInt(1);
      }
    });

    $('.tab-content-' + pid + ' .file_upload').each(function (index, element) {
      if ($(element).attr('type') === 'file') {
        // Check if the element is of type 'file'
        const fileInput = $(element)[0]; // Get the DOM element
        const files = fileInput.files; // Get the FileList object

        if (files.length > 0) {
          total_values_added = parseInt(total_values_added) + parseInt(1);
        }
      }
    });
    //alert(total_values_added)
    if (parseInt(value_needed) == parseInt(total_values_added)) {
      $('.summary_show_' + pid).css('display', 'initial');
    } else {
      $('.summary_show_' + pid).css('display', 'none');
    }
  }

  function removeAllValues(pid) {
    $('.tab-content-' + pid + ' .motivelist .items').removeClass('active');
    $('.tab-content-' + pid + ' .motive_text').val('');
    $('.tab-content-' + pid + " .motivelist input[type='file'].file_upload").val('');
  }

  function goToNextSection(step) {
    if (step > 1) {
      var current_step = parseInt(step) - parseInt(1);
    } else {
      var current_step = step;
    }
    $('.parent_tab_check_' + current_step).removeClass('step_in_process');
    $('.parent_tab_check_' + current_step).addClass('step_completed');

    var total_tabs = $('.gravuroptions .tabs .tab-item').length;
    if (step <= total_tabs) {
      if ($('.parent_tab_check_' + step).length > 0) {
        $('.parent_tab_check_' + step).trigger('click');
      }
    }
    //var target = document.getElementById("product_gravur__Wrapper");
    //target.scrollIntoView({ behavior: "smooth", block: "start" });
    var target = document.getElementById('product_gravur__Wrapper');
    smoothScroll(target, 1200, 50);
    return false;
  }

  //function SymbolClick(symbol, element) {
  //let engravingtext = element.closest('.engraving-text');
  //let select_file_box = engravingtext.querySelector('input');

  //}
  function SymbolOption(element) {
    let symbolSelection = element.closest('.engraving-text').querySelector('.symbol_selection');
    if (symbolSelection) {
      symbolSelection.style.display =
        symbolSelection.style.display === 'none' || symbolSelection.style.display === '' ? 'flex' : 'none';
    }
  }

  function SymbolClick(symbol, element) {
    // Find the closest engraving-text container
    const engravingTextContainer = element.closest('.engraving-text');
    if (engravingTextContainer) {
      // Find the input field inside the engraving-text container
      const inputField = engravingTextContainer.querySelector('textarea');
      const maxlength = inputField.getAttribute('maxlength');
      let charCount = inputField.value.length;
      if (maxlength) {
        if (charCount < maxlength) {
          // Append the symbol to the input field's value
          inputField.value += symbol;
          // Trigger the `input` event so `handleInputtext` runs
          inputField.dispatchEvent(new Event('input', { bubbles: true }));
        }
      } else {
        inputField.value += symbol;
        // Trigger the `input` event so `handleInputtext` runs
        inputField.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
  }

  function smoothScroll(target, duration, offset) {
    var startPosition = window.scrollY;
    var targetPosition = target.getBoundingClientRect().top + startPosition - offset;
    var startTime = null;

    function animation(currentTime) {
      if (startTime === null) startTime = currentTime;
      var timeElapsed = currentTime - startTime;
      var run = ease(timeElapsed, startPosition, targetPosition - startPosition, duration);
      window.scrollTo(0, run);
      if (timeElapsed < duration) requestAnimationFrame(animation);
    }

    function ease(t, b, c, d) {
      t /= d / 2;
      if (t < 1) return (c / 2) * t * t + b;
      t--;
      return (-c / 2) * (t * (t - 2) - 1) + b;
    }

    requestAnimationFrame(animation);
  }

$(document).on('click', '.filed', function () {
    console.log('click');
    if ($('.filed').hasClass('active')) {
      $('.active_bar.active').addClass('bold_bar');
    }
  });

  $(document).on('click', '.motivelist .items', function () {
    if ($('.motivelist .items').hasClass('active')) {
      $('.active_bar.active').addClass('bold_bar');
    }
  });

  $(document).on('click', '.info_col', function (event) {
    const $motiveList = $(this).closest('.motivelist');
    if ($(this).closest('.motivelist').find('.floating-section').length >= 1) {
      event.stopPropagation();
      $(this).closest('.motivelist').find('.floating-section').toggleClass('active');
      var page_slug = $(this).attr('attr-page-slug');
      $('body').addClass('floating-active');
      if (page_slug != '' && page_slug != undefined) {
        loadPageIntoDrawer('https://gravurschmuck.de/pages/' + page_slug, $motiveList);
      }
    }
  });
  $(document).on('click', '.floating-section .close-btn', function () {
    if ($(this).closest('.motivelist').find('.floating-section').length >= 1) {
      $(this).closest('.motivelist').find('.floating-section').toggleClass('active');
      $('body').removeClass('floating-active');
    }
  });

  async function loadPageIntoDrawer(url, $motiveList) {
    //console.log('page load data');
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Network response was not ok');
      //console.log('response text');
      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');

      const mainContent = doc.querySelector('#main');
      //console.log('mainContent---');
      //console.log(mainContent);
      if (mainContent) {
        //document.querySelector("#floatingSection .content-main").innerHTML = mainContent.innerHTML;
        const targetContent = $motiveList.find('.floating-section .content-main')[0];
        if (targetContent) {
          console.log('Total .content-main found:', targetContent.length);
          targetContent.innerHTML = mainContent.innerHTML;
        }
        //const elementsdata = document.querySelectorAll("#floatingSection .content-main");
        //console.log("Total .content-main found:", elementsdata.length);
      }
    } catch (e) {
      console.error('Error loading page:', e);
    }
  }

$(document).on('click', 'a.step-completed.final-step span.last-option', function () {
    var newText = $(this).attr('attr-change-text');
    if (newText) {
      $(this).text(newText);
    }
  });

  (function () {
    var assign = function (name, fn) {
      if (typeof fn === 'function') window[name] = fn;
    };
    assign('fontclick', typeof fontclick === 'function' ? fontclick : undefined);
    assign('sternzeichen_click', typeof sternzeichen_click === 'function' ? sternzeichen_click : undefined);
    assign('geburtsblumen_options_click', typeof geburtsblumen_options_click === 'function' ? geburtsblumen_options_click : undefined);
    assign('geburtsblumen_click', typeof geburtsblumen_click === 'function' ? geburtsblumen_click : undefined);
    assign('eigene_zeichnung_click', typeof eigene_zeichnung_click === 'function' ? eigene_zeichnung_click : undefined);
    assign('kindersymbole_click', typeof kindersymbole_click === 'function' ? kindersymbole_click : undefined);
    assign('kindersternzeichen_click', typeof kindersternzeichen_click === 'function' ? kindersternzeichen_click : undefined);
    assign('initialen_click', typeof initialen_click === 'function' ? initialen_click : undefined);
    assign('grafiken_click', typeof grafiken_click === 'function' ? grafiken_click : undefined);
    assign('eigene_handschrift_click', typeof eigene_handschrift_click === 'function' ? eigene_handschrift_click : undefined);
    assign('bild_text_click', typeof bild_text_click === 'function' ? bild_text_click : undefined);
    assign('pfotenabdruck_click', typeof pfotenabdruck_click === 'function' ? pfotenabdruck_click : undefined);
    assign('fingerabdruck_click', typeof fingerabdruck_click === 'function' ? fingerabdruck_click : undefined);
    assign('fu_abdruck_click', typeof fu_abdruck_click === 'function' ? fu_abdruck_click : undefined);
    assign('nasenabdruck_click', typeof nasenabdruck_click === 'function' ? nasenabdruck_click : undefined);
    assign('handabdruck_click', typeof handabdruck_click === 'function' ? handabdruck_click : undefined);
    assign('goToFinalStep', typeof goToFinalStep === 'function' ? goToFinalStep : undefined);
    assign('removeEngravingSelection', typeof removeEngravingSelection === 'function' ? removeEngravingSelection : undefined);
    assign('handleInputtext', typeof handleInputtext === 'function' ? handleInputtext : undefined);
    assign('uploadFile', typeof uploadFile === 'function' ? uploadFile : undefined);
    assign('showTabContent', typeof showTabContent === 'function' ? showTabContent : undefined);
    assign('showparentTabContentfirst', typeof showparentTabContentfirst === 'function' ? showparentTabContentfirst : undefined);
    assign('showSummaryButton', typeof showSummaryButton === 'function' ? showSummaryButton : undefined);
    assign('removeAllValues', typeof removeAllValues === 'function' ? removeAllValues : undefined);
    assign('goToNextSection', typeof goToNextSection === 'function' ? goToNextSection : undefined);
    assign('SymbolOption', typeof SymbolOption === 'function' ? SymbolOption : undefined);
    assign('SymbolClick', typeof SymbolClick === 'function' ? SymbolClick : undefined);
    assign('showparentTabContent', typeof showparentTabContent === 'function' ? showparentTabContent : undefined);
    assign('selectgravurart', typeof selectgravurart === 'function' ? selectgravurart : undefined);
    assign('goToNextStep', typeof goToNextStep === 'function' ? goToNextStep : undefined);
    assign('goToNextStep1', typeof goToNextStep1 === 'function' ? goToNextStep1 : undefined);
    assign('goToPreviousStep', typeof goToPreviousStep === 'function' ? goToPreviousStep : undefined);
    window.toggleFloatingSection = window.toggleFloatingSection || function () {};
  })();
